export const redoFunc = (
  tableData,
  setTableData,
  redoTableData,
  undoTableData
) => {
  if (redoTableData.length > 0) {
    undoTableData.push(tableData);
    setTableData(redoTableData[redoTableData.length - 1]);
    redoTableData.pop();
  }
};
